module.exports = __webpack_public_path__ + "site/img/indexnewyear1en.623d638c.jpg";